export const AddOnOtcCategoryTypeMap = {
    TOP_SELLERS: 'TOP_SELLERS',
    COVID_CARE: 'COVID_CARE',
    WOMENS_HEALTH: 'WOMENS_HEALTH',
    PAIN_FEVER_RELIEF: 'PAIN_FEVER_RELIEF',
    ALLERGY_ASTHMA: 'ALLERGY_ASTHMA',
    DIGESTIVE_HEALTH: 'DIGESTIVE_HEALTH',
    VITAMINS_SUPPLEMENTS: 'VITAMINS_SUPPLEMENTS',
    COLD_COUGH_FLU: 'COLD_COUGH_FLU',
    DIABETES: 'DIABETES',
    SKIN_CARE: 'SKIN_CARE',
    EYE_CARE: 'EYE_CARE',
    FIRST_AID: 'FIRST_AID',
    INFANTS_CHILDREN: 'INFANTS_CHILDREN',
    MED_MANAGEMENT: 'MED_MANAGEMENT',
    BUY_AGAIN: 'BUY_AGAIN',
    FEATURED: 'FEATURED',
    RECENTLY_ADDED: 'RECENTLY_ADDED',
    SEXUAL_WELLNESS: 'SEXUAL_WELLNESS',
    NEW_ARRIVALS: 'NEW_ARRIVALS',
    RECOMMENDED: 'RECOMMENDED',
    FERT_UPSELL: 'FERT_UPSELL',
    ENDO_UPSELL: 'ENDO_UPSELL',
};
//# sourceMappingURL=add_on_otc_category.js.map